export default __webpack_public_path__ + "static/media/discipline-medicine.8902df07.svg";